import React from "react";

export default function Rodape(){
    return( 
        <>       
        <div id="order">
            <button className="order-btn">Finalizar compra</button>
        </div>
        </>
        )
}